module.exports = __webpack_public_path__ + "img/ip_default_head.983e0848.jpg";